import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";
import { getUserData } from "../../utils/auth";

const initialState = {
  transactions: [],
  loading: false,
  error: null,
  totalExposure: 0,
};

const getUserIdForWallet = () => {
  try {
    const u = getUserData();
    return (
      u?._id ||
      u?.id ||
      u?.user_id ||
      u?.userId ||
      // lotus-web compatibility fallback
      localStorage.getItem("aid") ||
      ""
    );
  } catch {
    return localStorage.getItem("aid") || "";
  }
};

export const fetchWalletSummary = createAsyncThunk(
  "wallet/fetchSummary",
  async ({ from_date, to_date, limit }, { rejectWithValue }) => {
    try {
      const userId = getUserIdForWallet();
      const response = await axiosInstance.post("/wallet/getwalletsummary", {
        from_date,
        to_date,
        limit: limit || 100,
        user_id: userId,
      });

      if (response?.status === true) {
        const data = response.data;
        const items = (data?.getData || []).map((row) => ({
          transactionId: row._id || "",
          transactionType:
            row.statement_type === "DEPOSIT_REQUEST" ? "DEPOSIT" : "WITHDRAW",
          amount: Number(row.amount ?? 0),
          txStatus: row.status || "ACCEPTED",
          startTime: row.generated_at || "",
          notes: row.remark || "-",
          paymentMethod: row.payment_deatails?.[0]?.method_name || "-",
          images: row.images || "",
          paymentDetails: row.payment_deatails?.[0] || {},
        }));
        const exposure = data?.totalexposure?.[0]?.total || 0;
        return { items, exposure };
      }
      return rejectWithValue(response?.msg || "Failed to fetch wallet summary");
    } catch (error) {
      return rejectWithValue(
        error?.msg || error?.message || "Something went wrong",
      );
    }
  },
);

const walletSlice = createSlice({
  name: "wallet",
  initialState,
  reducers: {
    clearWalletData: (state) => {
      state.transactions = [];
      state.loading = false;
      state.error = null;
      state.totalExposure = 0;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWalletSummary.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWalletSummary.fulfilled, (state, action) => {
        state.loading = false;
        state.transactions = action.payload.items;
        state.totalExposure = action.payload.exposure;
      })
      .addCase(fetchWalletSummary.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearWalletData } = walletSlice.actions;
export default walletSlice.reducer;

